import './tasks.component';
import './edit-task/edit-task.component';
import './edit-task/stored-procedure-params-grid/stored-procedure-params-grid.component';
import './edit-task/edit-task-stored-procedure-form/edit-task-stored-procedure-form.component';
import './edit-task/parallel-settings/parallel-settings.component';